module.exports = __webpack_public_path__ + "img/quit_icon.79cfac72.svg";